import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const ServicesCTA = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="services-cta">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Ready to Get Started?
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto mb-8">
          Schedule a consultation with our experts and discover the best financial solutions for your needs.
        </p>
        <Link
          to="/contact"
          data-testid="services-final-cta"
          className="inline-flex items-center gap-2 gradient-btn px-10 py-4 rounded-full font-medium text-white"
        >
          Contact Us Today
          <ArrowRight size={18} />
        </Link>
      </motion.div>
    </div>
  </section>
);
